import { Theme } from './theme';

export const boxcryptorTheme: Theme = {
  light: {
    brand: {
      50: '#E7F8F2',
      100: '#b1e8d4',
      200: '#7fdcb7',
      300: '#40c594',
      400: '#21BC83',
      500: '#00b270', // ("Boxcryptor Green")
      600: '#01A361',
      700: '#009653',
      800: '#007b4c',
      900: '#005f37',
    },
    gray: {
      50: '#F9F8F7',
      100: '#F3F2F1',
      200: '#dfdede',
      300: '#bdbdbd',
      400: '#929191',
      500: '#717070',
      600: '#5c5b5b',
      700: '#363433',
      800: '#211f1d',
      900: '#100d0c',
    },
    white: '#FFFFFF',
    black: '#252424',
    focus: '#252424',
    body: '#FFFFFF',
  },
  dark: {
    brand: {
      50: '#0F422C',
      100: '#005f37',
      200: '#007b4c',
      300: '#009653',
      400: '#01A361',
      500: '#00b270', // ("Boxcryptor Green")
      600: '#40c594',
      700: '#7fdcb7',
      800: '#b1e8d4',
      900: '#E7F8F2',
    },
    gray: {
      50: '#292828',
      100: '#2d2c2c',
      200: '#414040',
      300: '#636262',
      400: '#8f8f8f',
      500: '#b1b0b0',
      600: '#c7c6c6',
      700: '#dddddd',
      800: '#eeeeee',
      900: '#FAF9F9',
    },
    white: '#201F1F', // must be switched to be exchangable to light mode
    black: '#FFFFFF', // must be switched to be exchangable to light mode
    focus: '#FFFFFF',
    body: '#201f1f',
  },
};

export const boxcryptorGreenWebsiteTheme: Theme = {
  light: {
    brand: {
      50: '#eefff9',
      100: '#bdffe6',
      200: '#7affce',
      300: '#38ffb5',
      400: '#00f49a',
      500: '#00b270', // ("Boxcryptor Green")
      600: '#008e5a', // ("Boxcryptor Logo Green")
      700: '#00774b',
      800: '#005f3c',
      900: '#00472d',
    },
    gray: {
      // Zinc
      50: '#FAFAFA',
      100: '#F4F4F5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717A',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
    },
    white: '#FFFFFF',
    black: '#252424',
    focus: '#252424',
    body: '#FFFFFF',
  },
  dark: {
    brand: {
      50: '#0F422C',
      100: '#005f37',
      200: '#007b4c',
      300: '#009653',
      400: '#01A361',
      500: '#00b270', // ("Boxcryptor Green")
      600: '#40c594',
      700: '#7fdcb7',
      800: '#b1e8d4',
      900: '#E7F8F2',
    },
    gray: {
      50: '#292828',
      100: '#2d2c2c',
      200: '#414040',
      300: '#636262',
      400: '#8f8f8f',
      500: '#b1b0b0',
      600: '#c7c6c6',
      700: '#dddddd',
      800: '#eeeeee',
      900: '#FAF9F9',
    },
    white: '#201F1F', // must be switched to be exchangable to light mode
    black: '#FFFFFF', // must be switched to be exchangable to light mode
    focus: '#FFFFFF',
    body: '#201f1f',
  },
};

export const boxcryptorEnterpriseTheme: Theme = {
  //Colors taken from msteams-ui-components-react v0.8.4, blue adjusted
  light: {
    brand: {
      50: '#e3f6ff',
      100: '#c7ecff',
      200: '#8fd9ff',
      300: '#57c6ff',
      400: '#1fb3ff',
      500: '#0098e6',
      600: '#0073ae', //("Whisply / Company Blue")
      700: '#006598',
      800: '#005683',
      900: '#004b70', // ("Enterprise Blue")
    },
    gray: {
      // Zinc
      50: '#FAFAFA',
      100: '#F4F4F5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717A',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
    },
    white: '#FFFFFF',
    black: '#252424',
    focus: '#252424',
    body: '#F3F2F1',
  },
  dark: {
    brand: {
      50: '#dbe9f4',
      100: '#bbd4e8',
      200: '#a1c6e4',
      300: '#89b8dd',
      400: '#66a9d4',
      500: '#4094c9',
      600: '#0073ae', //("Whisply / Company Blue")
      700: '#00679d',
      800: '#005985',
      900: '#004b70', // ("Enterprise Blue")
    },
    gray: {
      50: '#292828',
      100: '#2d2c2c',
      200: '#414040',
      300: '#636262',
      400: '#8f8f8f',
      500: '#b1b0b0',
      600: '#c7c6c6',
      700: '#dddddd', //added
      800: '#eeeeee', //added
      900: '#FAF9F9', //added
    },
    white: '#201F1F', // must be switched to be exchangable to light mode
    black: '#FFFFFF', // must be switched to be exchangable to light mode
    focus: '#FFFFFF',
    body: '#201F1F',
  },
};

export const msTeamsTheme: Theme = {
  //Colors taken from msteams-ui-components-react v0.8.4
  light: {
    brand: {
      50: '#F4F4FC',
      100: '#E2E2F6',
      200: '#BDBDE6',
      300: '#8B8CC7',
      400: '#7a7bb4',
      500: '#6264A7',
      600: '#5a5c9f', //added
      700: '#505296', //added
      800: '#464775',
      900: '#33344A',
    },
    gray: {
      50: '#F9F8F7',
      100: '#F3F2F1',
      200: '#dfdede',
      300: '#bdbdbd',
      400: '#929191',
      500: '#717070',
      600: '#5c5b5b',
      700: '#363433', //added
      800: '#211f1d', //added
      900: '#100d0c', //added
    },
    white: '#FFFFFF',
    black: '#252424',
    focus: '#252424',
    body: '#F3F2F1',
  },
  dark: {
    brand: {
      50: '#33344A',
      100: '#464775',
      200: '#505296', //added
      300: '#5a5c9f', //added
      400: '#6264A7',
      500: '#7a7bb4',
      600: '#8B8CC7',
      700: '#A6A7DC',
      800: '#BDBDE6',
      900: '#E2E2F6',
    },
    gray: {
      50: '#292828',
      100: '#2d2c2c',
      200: '#414040',
      300: '#636262',
      400: '#8f8f8f',
      500: '#b1b0b0',
      600: '#c7c6c6',
      700: '#dddddd', //added
      800: '#eeeeee', //added
      900: '#FAF9F9', //added
    },
    white: '#201F1F', // must be switched to be exchangable to light mode
    black: '#FFFFFF', // must be switched to be exchangable to light mode
    focus: '#FFFFFF',
    body: '#201F1F',
  },
};
